import { render, staticRenderFns } from "./EtsyRankCardTable.vue?vue&type=template&id=6148b42c&scoped=true"
import script from "./EtsyRankCardTable.vue?vue&type=script&lang=js"
export * from "./EtsyRankCardTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6148b42c",
  null
  
)

export default component.exports